import React, { ReactNode } from 'react';

import * as Sentry from '@sentry/react';

interface ErrorBoundaryProps {
    children: ReactNode;
    options?: Sentry.ErrorBoundaryProps;
    type?: ErrorBoundaryType;
}
export enum ErrorBoundaryType {
    basic,
    sentry,
}

export default function ErrorBoundary({
    children,
    type = ErrorBoundaryType.sentry,
    options,
}: ErrorBoundaryProps) {
    if (type === ErrorBoundaryType.sentry) {
        return (
            <Sentry.ErrorBoundary {...options}>{children}</Sentry.ErrorBoundary>
        );
    }
    return <>{children}</>;
}
